/**
 * Read-only calendar indicator with edit icon.
 * Shows the selected organizer/shared calendar.
 * Clicking the edit icon will open the shared calendar picker (wired in Phase 3B).
 */
import { Flex, Text } from '@chakra-ui/react';
import { Edit02 } from '@kula-ai/icons-core';
import { SCHEDULE_INTERVIEW_COPY } from '../../../config/schedule.copy';

interface CalendarFieldProps {
  calendarName?: string;
  calendarAvatar?: string;
  onEdit?: () => void;
  disabled?: boolean;
}

export const CalendarField = ({
  calendarName,
  onEdit,
  disabled = false,
}: CalendarFieldProps) => {
  const displayName = calendarName || 'Organizer calendar';

  return (
    <Flex align="center" justify="space-between" w="100%" py="1">
      <Flex align="center" gap="2">
        <Text fontSize="sm" color="secondary.600">
          {SCHEDULE_INTERVIEW_COPY.details.calendar.label}:
        </Text>
        <Text fontSize="sm" fontWeight="medium">
          {displayName}
        </Text>
      </Flex>
      {!disabled && onEdit && (
        <Flex
          as="button"
          align="center"
          justify="center"
          w="7"
          h="7"
          borderRadius="md"
          cursor="pointer"
          _hover={{ bg: 'gray.100' }}
          onClick={onEdit}
          aria-label="Edit calendar"
        >
          <Edit02 size={16} />
        </Flex>
      )}
    </Flex>
  );
};
